// extracted by mini-css-extract-plugin
export default {"sectionTitleContainer":"SectionTitle_sectionTitleContainer__RGD6S","sectionTitle":"SectionTitle_sectionTitle__-eCNR","bar":"SectionTitle_bar__VO5n7"};